import { useQuery } from '@tanstack/react-query';
import { ConversationDebug } from 'src/secret-menu/conversation-debugger/types';

export const useConversationDebug = (conversationId: string | null, tenantName: string | null) => {
  const { data, isLoading, isError } = useQuery<ConversationDebug>({
    queryKey: ['admin', 'conversations', conversationId, 'debug', { tenantName }],
    enabled: !!conversationId && !!tenantName,
  });

  return { conversation: data, isLoading, isError };
};
